import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
    IFormInputType,
    IDimensionUnit,
    IFormFieldDimensionDefaultValueKey,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import additionalDataFactory from './common/fieldsAdditionalData';
import { fieldsCounterBarBorder, fieldsCounterBarCutting, fieldsCounterBarTrayMaterial } from './common/fieldsCounterBar';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const counterBarForm: IForm = {
    formId       : PublishedFormId.CounterBarCurved,
    type         : FormTypeId.CounterBar,
    thumbnailURL : '/resized-images/forms/counterBarCurved.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.TrayMaterial,
        IFormFieldKey.TrayDimension,
        IFormFieldKey.Border,
        IFormFieldKey.Cutting,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        trayMaterial  : fieldsCounterBarTrayMaterial,
        trayDimension : {
            [FieldDimensionId.Length]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 500, max: 6000 },
                required     : true,
                defaultValue : 2000,
            },
            [FieldDimensionId.Width]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 500, max: 4000 },
                required     : true,
                defaultValue : 600,
            },
            [FieldDimensionId.Thickness]: {
                value         : undefined,
                type          : IFormInputType.Range,
                unit          : IDimensionUnit.Centimeters,
                step          : 10,
                range         : { min: 10, max: 200 },
                required      : true,
                defaultValue  : 80,
                defaultValues : [
                    [IFormFieldDimensionDefaultValueKey.StandardThickness, 80],
                    [IFormFieldDimensionDefaultValueKey.MediumThickness, 120],
                    [IFormFieldDimensionDefaultValueKey.LargeThickness, 180],
                ],
            },
        },
        border         : fieldsCounterBarBorder,
        cutting        : fieldsCounterBarCutting,
        additionalData : additionalDataFactory({
            budgetMin          : 1000,
            budgetMax          : 35000,
            budgetDefaultValue : 7000,
            marks              : budgetMarksBuilder(1000, 250, 14000, 1000, 35000),
        }),
        contact: fieldsContact,
    },
};

export default counterBarForm;
